export default function PHP_strtolower() {
  return (
    <div>
      <h1>PHP_strtolower</h1>
    </div>
  );
}
